import React from 'react';
import styled from '@emotion/styled';
import { useDynamicUrlPath } from 'client/hooks/useDynamicUrlPath';
import { Button } from 'client/shared/Button/NewButton';
import { useT } from 'client/i18n/hooks/useT';
import { SCREEN_BREAKPOINTS } from '../../../constants';
import { AdsByAnchorLogo } from '../../AdsByAnchorLogo';

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 640px;
  margin: auto;
  padding: 88px 0 0;

  .ads-by-anchor-logo {
    width: 100%;
    max-width: 273px;
  }

  .ads-by-anchor-signup-button {
    margin: 0 auto;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    width: 90%;
    padding: 0;
  }
`;
const HeaderTitle = styled.h1`
  margin-bottom: 24px;
  color: white;
  font-weight: 200;
  font-size: 74px;
  letter-spacing: -4px;
  text-align: center;
`;

const HeaderSubtitle = styled.p`
  margin: 0 0 30px;
  color: #ffffff;
  font-size: 1.625rem;
  line-height: 2.25rem;
  letter-spacing: -0.01em;
  text-align: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 0 0 25px;
    font-size: 1.375rem;
    line-height: 1.75rem;
  }
`;

export const HeaderContent = () => {
  const { path } = useDynamicUrlPath({ destinationPath: '/dashboard/money' });
  const t = useT();
  return (
    <HeaderContentContainer>
      <HeaderTitle>
        <AdsByAnchorLogo aria-hidden={true} id="ads-by-anchor-icon-header" />
      </HeaderTitle>

      <HeaderSubtitle>
        {t(
          'AdsByAnchorScreen.Header.HeaderContent.Subtitle',
          'The all-in-one, flexible podcast monetization platform made for everyone, powered by Spotify.',
          ''
        )}
      </HeaderSubtitle>
      <Button
        className="ads-by-anchor-signup-button"
        color="yellow"
        kind="link"
        href={path}
      >
        {t(
          'AdsByAnchorScreen.Header.HeaderContent.SignupButtonLabel',
          'Sign up',
          'Sign up button text'
        )}
      </Button>
    </HeaderContentContainer>
  );
};
